<template>
    <div class="menu-icon cursor-pointer" @click.stop="toggleMenu(false)">
        <a-popover placement="right" v-model="tipsVisible">
            <img src="/assets/images/index/icon-7.png" alt="">
            <div slot="content">展开侧边栏</div>
        </a-popover>
    </div>
</template>
<script>
export default {
    name: 'AtMenuIcon',
    data() {
        return {
            tipsVisible: false,
        }
    },
    mounted() {
        this.showTips();
    },
    methods: {
        showTips() {
            
            let isShowTips = localStorage.getItem('_show_index_left_menu_tips_' + this.$route.path)
            
            if (isShowTips == '1') return;
            
            localStorage.setItem('_show_index_left_menu_tips_' + this.$route.path, '1');
            
            this.$nextTick(() => {
                this.tipsVisible = true;
            })
        },
        toggleMenu(hide) {
            this.$toggleMenu(hide);
        }
    }
}
</script>
<style scoped>
.menu-icon {
    display: inline-block;
    
    img {
        width: 24px;
        height: 24px;
    }
}
</style>